import instanceQuery from 'graphql/queries/schedules/BusinessRuleQuery.graphql';
import mutationQuery from 'graphql/mutations/schedules/BusinessRuleMutation.graphql';
import fragment from 'graphql/fragments/schedules/BusinessRuleFragment.graphql';
import listQuery from 'graphql/queries/schedules/BusinessRuleListQuery.graphql';
import workspaceQuery from 'graphql/queries/schedules/BusinessRuleWorkspaceQuery.graphql';

import { workspace } from 'actions/schedule/BusinessRuleWorkspaceAction';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const BusinessRule = {
  type: 'BusinessRule',
  title: 'Business Rules',
  formTitle: 'Business Rule',
  formUrl: '/Company/BusinessRules/Details/',
  workspaceUrl: '/Company/BusinessRules/Workspace/',
  workspace: workspaceQuery,
  instance: instanceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'BUSINESS_RULES',
  actions: [...workspace],
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default BusinessRule;
